<div class="flex overflow-hidden h-full">
    <form [formGroup]="createUser" class="flex overflow-hidden h-full gap-20">
        <div class="h-full">
            <div class="h-full w-28rem bg-white flex flex-column justify-content-between border-round-lg">
                <div class="flex align-items-center justify-content-between p-4">
                    <p class="text-semibold m-2 text-lg">
                        {{ (updateUser ? 'default-cm-update' : 'default-cm-create') | translate }}
                    </p>
                    @if (!updateUser) {
                        <p-button styleClass="shadow-none" [text]="true" (click)="ClearAll()">{{
                            'default-cm-clearAll' | translate: 'Clear All'
                        }}</p-button>
                    }
                </div>
                <div class="overflow-scroll pb-4">
                    <div class="flex flex-column px-4 h-full pb-8">
                        <span class="p-float-label mt-3 w-full p-input-icon-right">
                            <input
                                #userNameInput
                                pInputText
                                type="text"
                                formControlName="userName"
                                placeholder="{{ 'default-cm-userName' | translate: 'Username' }}"
                                [readonly]="updateUser"
                                class="height-40 w-full"
                            />
                            <i p-input-icon-right class="bg-white">{{ userName?.value?.length || 0 }}/255</i>
                            <label htmlFor="page-name">{{ 'default-cm-userName' | translate: 'Username' }}</label>
                            @if (userName && userName?.value && userName?.value.length > 255) {
                                <span class="text-red-500 text-sm"
                                    >{{
                                        'default-character-exceed'
                                            | translate
                                                : 'Cannot exceed
                                255
                                characters'
                                    }}
                                </span>
                            }
                        </span>
                        @if (createUser.controls['userName'].touched && createUser.controls['userName'].errors) {
                            @if (createUser.controls['userName'].errors['required']) {
                                <span class="text-red-500 text-sm">Please enter username</span>
                            }
                        }
                        <span class="p-float-label mt-3 w-full">
                            <input
                                pInputText
                                type="number"
                                formControlName="bandwidth"
                                placeholder="{{ 'default-cm-bandwidth' | translate: 'Bandwidth' }}"
                                class="height-40 w-full"
                            />
                            <label htmlFor="page-name">{{ 'default-cm-bandwidth' | translate: 'Bandwidth' }}</label>
                        </span>

                        @if (createUser.get('bandwidth')?.touched && createUser.get('bandwidth')?.errors) {
                            <span class="text-red-500 text-sm">Please enter band width</span>
                        } @else if (createUser.hasError('bandwidthGreaterThanDailyLimit')) {
                            <span class="text-red-500 text-sm">
                                Bandwidth should be less than or equal to daily limit.
                            </span>
                        }
                        @if (updateUser) {
                            <span class="p-float-label mt-3 w-full">
                                <input
                                    pInputText
                                    formControlName="remainingBandwidth"
                                    type="number"
                                    class="height-40 w-full"
                                    readonly="true"
                                />
                                <label htmlFor="page-name">{{
                                    'default-cm-remainingBandwidth' | translate: 'Remaining Bandwidth'
                                }}</label>
                            </span>
                        }
                        <span class="p-float-label mt-3 w-full">
                            <input
                                pInputText
                                type="number"
                                formControlName="dailyLimit"
                                placeholder="{{ 'default-cm-dailyLimit' | translate: 'Daily Limit' }}"
                                class="height-40 w-full"
                            />
                            <label htmlFor="page-name">{{ 'default-cm-dailyLimit' | translate: 'Daily Limit' }}</label>
                        </span>
                        @if (
                            createUser.controls['dailyLimit'].touched &&
                            createUser.controls['dailyLimit'].errors?.['required']
                        ) {
                            <span class="text-red-500 text-sm">Please enter daily limit</span>
                        }
                        @if (updateUser) {
                            <span class="p-float-label mt-3 w-full">
                                <input
                                    pInputText
                                    formControlName="remainingDailyLimit"
                                    type="number"
                                    class="height-40 w-full"
                                    readonly="true"
                                />
                                <label htmlFor="page-name">{{
                                    'default-cm-remainingDailyLimit' | translate: 'Remaining Daily Limit'
                                }}</label>
                            </span>
                        }
                        <span
                            class="p-float-label mt-3 w-full flex justify-content-end p-2 surface-border border-1 border-round"
                        >
                            <p-inputSwitch formControlName="isActive" />
                            <label htmlFor="page-name">{{ 'default-cm-status' | translate: 'Status' }}</label>
                        </span>
                        <span
                            class="p-float-label mt-3 w-full flex justify-content-end p-2 surface-border border-1 border-round"
                        >
                            <p-inputSwitch formControlName="enableTaskDistribution" />
                            <label htmlFor="page-name">{{
                                'default-cm-taskDistribution' | translate: 'Task Distribution'
                            }}</label>
                        </span>
                        <div class="flex mt-3 flex-column gap-4 w-full surface-ground h-full text-gray-300">
                            @for (page of categories; track pIndex; let pIndex = $index) {
                                <div class="w-full flex flex-column gap-2 w-full surface-ground">
                                    <div class="flex flex-column gap-2">
                                        <div class="flex align-items-start w-full">
                                            <span class="text-medium text-sm line-height-3 text-gray-200">{{
                                                page.categoryMenu | translate
                                            }}</span>
                                        </div>
                                        <div
                                            class="w-full border-round-lg flex flex-column surface-border border-1 justify-content-center"
                                        >
                                            @for (singlePage of page.items; track i; let i = $index) {
                                                <div
                                                    class="hover:surface-hover h-4rem   p-3 flex surface-border align-items-center cursor-pointer justify-content-between {{
                                                        page.items.length - 1 == i ? '' : 'border-bottom-1'
                                                    }}"
                                                    [ngClass]="{
                                                        'text-primary-700 surface-600':
                                                            activePageMenu['activeMenuCategory'] === pIndex &&
                                                            activePageMenu['activeCategoryItem'] === i,
                                                    }"
                                                    (click)="setMenu(singlePage, pIndex, i)"
                                                >
                                                    <div class="flex align-items-center justify-content-center gap-2">
                                                        <img
                                                            [src]="
                                                                activePageMenu['activeMenuCategory'] === pIndex &&
                                                                activePageMenu['activeCategoryItem'] === i
                                                                    ? 'assets/icons/' + singlePage?.activeIcon
                                                                    : 'assets/icons/' + singlePage?.icon
                                                            "
                                                        />
                                                        <span
                                                            class="font-medium capitalize overflow-hidden white-space-nowrap text-overflow-ellipsis"
                                                        >
                                                            {{ singlePage.title | translate }}</span
                                                        >
                                                    </div>
                                                    @if (
                                                        activePageMenu['activeMenuCategory'] === pIndex &&
                                                        activePageMenu['activeCategoryItem'] === i
                                                    ) {
                                                        <i class="pi pi-angle-right text-lg"></i>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="flex w-full gap-3 px-4 py-3">
                    <div class="flex-1">
                        <p-button
                            label="{{ 'default-cm-cancel' | translate: 'Cancel' }}"
                            [outlined]="true"
                            styleClass="w-full"
                            (onClick)="cancel()"
                        ></p-button>
                    </div>
                    <div class="flex-1">
                        <p-button
                            [label]="
                                updateUser
                                    ? ('default-cm-update' | translate: 'Update')
                                    : ('default-cm-create' | translate: 'Create')
                            "
                            styleClass="w-full"
                            [disabled]="createUser.invalid"
                            (onClick)="submit()"
                        ></p-button>
                    </div>
                </div>
            </div>
        </div>
        @if (sideBar) {
            <div class="h-full w-30rem bg-white border-round-lg flex flex-column">
                <div class="flex justify-content-between p-4">
                    @for (item of headers; track $index) {
                        @if ($index == activeMenuIndex) {
                            <p class="text-semibold m-2 text-lg">{{ item | translate }}</p>
                        }
                    }
                    <p-button styleClass="shadow-none" icon="pi pi-times" [text]="true" (click)="close()"></p-button>
                </div>
                @if (selectTabMenu.label === 'skill_name') {
                    <app-editable-list
                        class="flex flex-1 flex-column overflow-hidden"
                        [items]="selectTabMenu.filterData"
                        (searchChange)="filter($event)"
                        (editClick)="editItem($event)"
                        (deleteClick)="deleteItem($event)"
                        (addClick)="addNewSkill()"
                    />
                } @else if (selectTabMenu.label === 'reportees') {
                    <app-checkbox-list
                        class="flex flex-1 flex-column overflow-hidden"
                        [items]="selectTabMenu.filterData"
                        labelKey="username"
                        checkedKey="reportee"
                        disabledKey="disabled"
                        [disabledTooltipFn]="reporteeDisabledTooltip"
                        (selectionChange)="toggleSelection($event)"
                        (searchChange)="filter($event)"
                    />
                } @else {
                    <app-checkbox-list
                        class="flex flex-1 flex-column overflow-hidden"
                        [items]="selectTabMenu.filterData"
                        [labelKey]="selectTabMenu.label"
                        [showSelectAll]="true"
                        [badgeKey]="selectTabMenu.label === 'group_name' ? 'number_of_users' : ''"
                        [showMoreEnabled]="selectTabMenu.label === 'group_name'"
                        [allLoaded]="allGroupsLoaded"
                        [loadMoreError]="loadMoreGroupsError"
                        (selectionChange)="toggleSelection($event)"
                        (selectAllChange)="onSelectAll($event)"
                        (searchChange)="filter($event)"
                        (loadMore)="loadMoreGroups()"
                    />
                }
            </div>
        }
    </form>
</div>
